import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const usePredictiveAverageLotValueInElastic = () => {
    const hasPredictiveAverageLotValueInElasticControl = useAmplitudeExperimentBase(
        AmplitudeExperiments.PredictiveAverageLotValueInElastic,
        AmplitudeVariants.PredictiveAverageLotValueInElastic.Control
    );

    const hasPredictiveAverageLotValueInElasticAddOnlyMLSignals = useAmplitudeExperimentBase(
        AmplitudeExperiments.PredictiveAverageLotValueInElastic,
        AmplitudeVariants.PredictiveAverageLotValueInElastic.AddOnlyMLSignals
    );

    const hasPredictiveAverageLotValueInElasticFullRerank = useAmplitudeExperimentBase(
        AmplitudeExperiments.PredictiveAverageLotValueInElastic,
        AmplitudeVariants.PredictiveAverageLotValueInElastic.FullRerank
    );

    const hasPredictiveAverageLotValueInElasticPredictedExpectedValueRerank = useAmplitudeExperimentBase(
        AmplitudeExperiments.PredictiveAverageLotValueInElastic,
        AmplitudeVariants.PredictiveAverageLotValueInElastic.PredictedExpectedValueRerank
    );

    return {
        hasPredictiveAverageLotValueInElasticAddOnlyMLSignals,
        hasPredictiveAverageLotValueInElasticControl,
        hasPredictiveAverageLotValueInElasticFullRerank,
        hasPredictiveAverageLotValueInElasticPredictedExpectedValueRerank,
    };
};
